import _extends from "@babel/runtime/helpers/esm/extends";
var _IconFirstPage, _IconKeyboardArrowLef, _IconKeyboardArrowRig, _IconLastPage;
import React from 'react';
import { Box, IconButton, IconFirstPage, IconKeyboardArrowLeft, IconKeyboardArrowRight, IconLastPage, Typography } from '@lumahealthhq/ui-core';
import { useIntl } from '../../../../../hooks';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
/**
 * @ignore - internal component.
 */

function ActionsComponent({
  page,
  count,
  onPageChange,
  rowsPerPage,
  nextIconButtonProps,
  backIconButtonProps
}) {
  const intl = useIntl();
  const totalPages = (Math.ceil(count / rowsPerPage) || 1) - 1;
  const disablePreviousBtn = page === 0;
  const disableNextBtn = page === totalPages;
  return /*#__PURE__*/_jsxs(Box, {
    sx: {
      display: 'flex',
      alignItems: 'center'
    },
    children: [/*#__PURE__*/_jsx(IconButton, _extends({
      "aria-label": intl.formatMessage({
        id: "knwFH9",
        defaultMessage: [{
          "type": 0,
          "value": "Go to the first page"
        }]
      }),
      disabled: disablePreviousBtn,
      size: "small",
      onClick: e => onPageChange(e, 0)
    }, backIconButtonProps, {
      children: _IconFirstPage || (_IconFirstPage = /*#__PURE__*/_jsx(IconFirstPage, {
        fontSize: "small"
      }))
    })), /*#__PURE__*/_jsx(IconButton, _extends({
      "aria-label": intl.formatMessage({
        id: "BurBcW",
        defaultMessage: [{
          "type": 0,
          "value": "Go to the previous page"
        }]
      }),
      disabled: disablePreviousBtn,
      size: "small",
      onClick: e => onPageChange(e, page - 1)
    }, backIconButtonProps, {
      children: _IconKeyboardArrowLef || (_IconKeyboardArrowLef = /*#__PURE__*/_jsx(IconKeyboardArrowLeft, {
        fontSize: "small"
      }))
    })), /*#__PURE__*/_jsx(Typography, {
      sx: {
        px: 1
      },
      variant: "body2",
      children: intl.formatMessage({
        id: "3kNr3U",
        defaultMessage: [{
          "type": 0,
          "value": "Page "
        }, {
          "type": 1,
          "value": "page"
        }, {
          "type": 0,
          "value": " of "
        }, {
          "type": 1,
          "value": "totalPages"
        }]
      }, {
        page: page + 1,
        totalPages: totalPages + 1
      })
    }), /*#__PURE__*/_jsx(IconButton, _extends({
      "aria-label": intl.formatMessage({
        id: "y/bgxe",
        defaultMessage: [{
          "type": 0,
          "value": "Go to the next page"
        }]
      }),
      disabled: disableNextBtn,
      size: "small",
      onClick: e => onPageChange(e, page + 1)
    }, nextIconButtonProps, {
      children: _IconKeyboardArrowRig || (_IconKeyboardArrowRig = /*#__PURE__*/_jsx(IconKeyboardArrowRight, {
        fontSize: "small"
      }))
    })), /*#__PURE__*/_jsx(IconButton, _extends({
      "aria-label": intl.formatMessage({
        id: "9Zocms",
        defaultMessage: [{
          "type": 0,
          "value": "Go to the last page"
        }]
      }),
      disabled: disableNextBtn,
      size: "small",
      onClick: e => onPageChange(e, totalPages)
    }, nextIconButtonProps, {
      children: _IconLastPage || (_IconLastPage = /*#__PURE__*/_jsx(IconLastPage, {
        fontSize: "small"
      }))
    }))]
  });
}
export default ActionsComponent;